// extracted by mini-css-extract-plugin
module.exports = {"staticContentWrapper":"styles_staticContentWrapper__26NCA","staticContentItem":"styles_staticContentItem__1aCjs"};